import {
   OTP_SENT,
   LOGIN_SUCCESS,
   GUEST_LOGIN_SUCCESS,
   GUEST_MODAL,
   LOGOUT
   // LOGIN_FAIL,
   // USER_LOADED,
   // AUTH_ERROR,
   // LOGOUT,
   // ACCOUNT_CAPTURED,
   // AUTHENTICATION,
   // VALIDATION,
} from "../actions/types";

const initialState = {
   token: localStorage.getItem("kidex-sd-token"),
   isAuthenticated: null,
   loading: true,
   user: null,
   mobile: null,
   account: {},
   authentication: {},
   validation: {},
   guestModal: true,
   showDemo: false,
};

export default function (state = initialState, action) {

   const { type, payload } = action;
   switch (type) {
      //   case USER_LOADED:
      //     return {
      //       ...state,
      //       isAuthenticated: true,
      //       loading: false,
      //       user: payload,
      //     };
      case OTP_SENT:
         return {
            ...state,
            isAuthenticated: false,
            mobile: payload,
         };
      case LOGIN_SUCCESS:
      case GUEST_LOGIN_SUCCESS:
         return {
            ...state,
            ...payload,
            isAuthenticated: true,
            loading: false,
         };
      case GUEST_MODAL:
         return { ...state, guestModal: payload }
      case LOGOUT:
         localStorage.removeItem("kidex-sd-token");
         localStorage.removeItem("guest");
         return {
            ...state,
            token: null,
            isAuthenticated: false,
            loading: false,
         };
      //   case ACCOUNT_CAPTURED:
      //     return { ...state, account: payload }
      //   case AUTHENTICATION:
      //     return { ...state, authentication: payload }
      //   case VALIDATION:
      //     return { ...state, validation: payload }
      default:
         return state;
   }
}
